import store from "fragments/vendors/store"
import { gql } from "graphql-tag"

const GET_STORES_WAVE = gql`
  ${store}

  query getStoresWave($query: GetWaveQueryStores) {
    getStoresWave(query: $query) {
      stores {
        ...Store
      }
      cursor
      hasPrevData
      hasNextData
      prevCursor
    }
  }
`

export default GET_STORES_WAVE
